<template>
  <scroll-view class="register-index" :scroll="true">
    <div class="register-flex-text">用户注册</div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 0 ? '#ff0000' : '#000'}">账号</div>
      <input class="information-item-text" v-model="value_account" placeholder="请输入账号" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 1 ? '#ff0000' : '#000'}">密码</div>
      <input class="information-item-text" v-model="value_password" placeholder="请输入密码" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 2 ? '#ff0000' : '#000'}">确认密码</div>
      <input class="information-item-text" v-model="value_exactpassword" placeholder="请再次输入密码" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 3 ? '#ff0000' : '#000'}">联系人</div>
      <input class="information-item-text" v-model="value_contacts" placeholder="请输入联系人" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 4 ? '#ff0000' : '#000'}">公司名称</div>
      <input class="information-item-text" v-model="value_name" placeholder="请输入公司名称" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 5 ? '#ff0000' : '#000'}">公司地址</div>
      <input class="information-item-text" v-model="value_address" placeholder="请输入公司地址" />
    </div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 6 ? '#ff0000' : '#000'}">联系手机</div>
      <input class="information-item-text" v-model="value_mobile" placeholder="请输入联系手机" />
    </div>
    <div class="register-flex-text">图库信息</div>
    <div class="information-item">
      <div :style="{width: '8rem',color: index == 7 ? '#ff0000' : '#000'}">图库名称</div>
      <input class="information-item-text" v-model="value_gallery" placeholder="请输入图库名称" />
    </div>
    <div class="register-flex-button" @click="moreTap()">注册</div>
  </scroll-view>
</template>

<script>
  import {
    AlbumsenopenAccount
  } from '@/request/api.js'
  export default {
    data() {
      return {
        value_account:'',
        value_password:'',
        value_exactpassword:'',
        value_contacts:'',
        value_name:'',
        value_address:'',
        value_mobile:'',
        value_gallery:'',
        index:99
      }
    },
    created() {
      typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
    },
    methods: {
      router(){
        this.$router.push({
          path: url
        })
      },
      async moreTap(){
        let _self = this;
        if(this.value_account.length == 0){
          this.index = 0;
          return;
        }
        if(this.value_password.length == 0){
          this.index = 1;
          return;
        }
        if(this.value_exactpassword.length == 0 || this.value_exactpassword != this.value_password){
          this.index = 2;
          return;
        }
        if(this.value_contacts.length == 0){
          this.index = 3;
          return;
        }
        if(this.value_name.length == 0){
          this.index = 4;
          return;
        }
        if(this.value_address.length == 0){
          this.index = 5;
          return;
        }
        if(this.value_mobile.length != 11){
          this.index = 6;
          return;
        }
        if(this.value_gallery.length == 0){
          this.index = 7;
          return;
        }
        this.index = 99;
        let param = {
          username:this.value_account,
          password:this.value_password,
          password2:this.value_exactpassword,
          link_man:this.value_contacts,
          company_name:this.value_name,
          address:this.value_address,
          mobile:this.value_mobile,
          name:this.value_gallery
        }
        let res = await AlbumsenopenAccount(param);
        this.$api.Message('提示', '注册成功').then((res) => {
          _self.$router.push({
            path: '/contactCatalog/progeny/signIn'
          })
        })
      }
    }
  }
</script>

<style lang="less">
  .register-index {
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F4F4F4;


    .register-flex-text {
      width: 90%;
      margin-bottom: 1rem;
      padding: 0.5rem 2%;
      margin-left: 3%;
      color: #999;
      margin-top: 3rem;
    }

    .register-flex-button {
      width: 90%;
      background-color: #2590c8;
      color: #FFFFFF;
      padding: 1rem 2%;
      border-radius: 0.5rem;
      text-align: center;
      margin-left: 3%;
      margin-top: 30px;
    }

    .information-item {
      width: 94%;
      padding: 3%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.2rem;
      background-color: #FFFFFF;
      border-bottom: 1px solid #F4F4F4;
    }
    .information-item>div {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
    }

    .information-item-text {
      flex: 1;
      color: #999;
    }
  }
</style>
